import {Component, computed, inject, input, output} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {ArchiveIcon, LucideAngularModule, SquarePenIcon} from 'lucide-angular';
import {RouterLink} from '@angular/router';
import {VenuePipe} from '@domain/venue/pipe/venue.pipe';
import {ActivityDTO, ActivityState} from '@domain/activity/activity.dto';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';
import {CoverViewerComponent} from '@shared/form/media/cover-uploader/cover-viewer/cover-viewer.component';
import {
  ActivityTagManagerComponent
} from '@domain/activity/component/activity-tag-manager/activity-tag-manager.component';
import { ActivityApi } from '@domain/activity/activity.api';

@Component({
  selector: 'app-activity-about',
  providers: [
    VenuePipe
  ],
  imports: [
    TranslocoDirective,
    LucideAngularModule,
    RouterLink,
    CoverViewerComponent,
    ActivityTagManagerComponent
  ],
  templateUrl: './activity-about.component.html'
})
export class ActivityAboutComponent {

  public readonly isPreview = input.required<boolean>();
  public readonly hostUrl = input.required<string>();
  public readonly canEdit = input(false);
  public readonly canManageTags = input(false);

  public readonly edit = output<void>();

  private readonly activityApi = inject(ActivityApi);

  public readonly icons = {
    archived: ArchiveIcon,
    edit: SquarePenIcon
  };
  public readonly activity = input.required<ActivityDTO>();
  public readonly isArchived = computed(() => this.activity().state === ActivityState.Archived);
  public readonly host = computed(() => this.activity().mainHost);
  public readonly hostName = computed(() => this.activity().mainHost?.name ?? '');

  public readonly coverUrl = computed(() => this.activityApi.getCoverUrl(this.activity().id));
  public readonly thumbnailUrl = computed(() => this.activityApi.getThumbnailUrl(this.activity().id));

  public readonly routes = {
    home: RouteGenerator.abs(UI_ROUTES.public.dashboard),
    search: RouteGenerator.abs(UI_ROUTES.public.activity.search)
  };

  public editClick(): void {
    this.edit.emit();
  }

}
